import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/reactflow.patch.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Space_Grotesk\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-space\"}],\"variableName\":\"fSpaceGrotesk\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Prompt\",\"arguments\":[{\"subsets\":[\"thai\"],\"weight\":[\"100\",\"200\",\"300\",\"400\",\"600\"],\"display\":\"swap\",\"variable\":\"--font-prompt\"}],\"variableName\":\"fPrompt\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Controllers"] */ "/vercel/path0/src/layout/_controllers/controllers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Modal"] */ "/vercel/path0/src/layout/_global/modal/modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toast"] */ "/vercel/path0/src/layout/_global/toast/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/layout/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Nav"] */ "/vercel/path0/src/layout/nav/index.tsx");
